import "./PlanComparisonTable.css";

import { TextWithLineBreaks } from "../../../../Components/TextWithLineBreaks";

// ========================================
//  Edit the data below to update the table
// ========================================

const PLANS = [
    {
        name: "Basic",
        checkClass: "check-blue",
        subtitle: "킨들 전자책 단독\n(KDP + Kindle · 저자 계정 등록)",
        features: [
            { text: "KDP 계정 & Tax Profile 최적화 설정" },
            { text: "전자책 내지 / 표지 제작\n(KDP 전용 규격 · 시안 3개 · 수정 1회)" },
            { text: "메타데이터 / 키워드 / 도서 소개 최적화" },
            { text: "Kindle Previewer 포함 품질 최종 검수" },
            { text: "글로벌 출간 및 유통 등록" },
            { text: "Author Central 구축 가이드 PDF 제공" },
            { text: "수정 1회 · 30일 사후 지원" },
        ],
    },
    {
        name: "Pro",
        checkClass: "check-orange",
        subtitle: "전자책+종이책\n(KDP + Paperback · 저자 계정 등록)",
        features: [
            { text: "Basic 모든 항목 포함", bold: true },
            { text: "종이책 내지 조판 (6×9 기준)" },
            { text: "종이책 전문 표지 디자인\n(Spine 포함 · 시안 2개 · 수정 1회)" },
            { text: "Author Central + SEO / AMS Ads\n초기 설정 (마케팅 가이드 패키지 PDF 제공)" },
            { text: "수정 2회 · 60일 사후 지원" },
        ],
    },
];

// ========================================

function PlanColumn({ plan }) {
    return (
        <div className="plan-comparison-table-column">
            <div className="plan-comparison-table-header">
                {plan.name}
            </div>

            <div className="plan-comparison-table-body">
                <div className="plan-comparison-table-subtitle">
                    <TextWithLineBreaks text={plan.subtitle} />
                </div>

                <div className="plan-comparison-table-divider" />

                <ul className="plan-comparison-table-features">
                    {plan.features.map((feature, index) => (
                        <li key={index} className="plan-comparison-table-feature-item">
                            <img
                                src="/images/check.png"
                                alt="check"
                                className={`plan-comparison-table-check ${plan.checkClass}`}
                            />
                            <span className={feature.bold ? "plan-comparison-table-feature-text bold" : "plan-comparison-table-feature-text"}>
                                <TextWithLineBreaks text={feature.text} />
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

function PlanComparisonTable() {
    return (
        <div className="plan-comparison-table">
            {PLANS.map((plan) => (
                <PlanColumn key={plan.name} plan={plan} />
            ))}
        </div>
    );
}

export default PlanComparisonTable;
